import moment, { Moment } from 'moment';

/**
 * Corregge il fuso delle date inviate dal server.
 */
export function fromServerIsoString(dateStr: string): Moment {
    const date = moment(dateStr);
    return date.subtract(date.utcOffset(), 'm').utc();
}

/**
 * Converti le proprietà in camelCase.
 */
export function convertPropertiesToCamelCase<T>(object: unknown): T {
    const str = JSON.stringify(object);
    return JSON.parse(str, (key: string, value: unknown) => {
        if (typeof value === 'object' && value) {
            for (let k in value) {
                if (Object.hasOwnProperty.call(value, k) && /^[A-Z]/.test(k)) {
                    value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                    delete value[k];
                }
            }
        }
        return value;
    });
}

/**
 * Converti le proprietà in PascalCase.
 */
export function convertPropertiesToPascalCase<T>(object: unknown): T {
    const str = JSON.stringify(object);
    return JSON.parse(str, (key, value) => {
        if (typeof value === 'object' && value) {
            for (let k in value) {
                if (Object.hasOwnProperty.call(value, k) && /^[a-z]/.test(k)) {
                    value[k.charAt(0).toUpperCase() + k.substring(1)] = value[k];
                    delete value[k];
                }
            }
        }
        return value;
    });
}
